import React from 'react'
import SettingListTable from './Components/SettingListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const SettingList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Setting List</HeadingOne>
          <AddItemBtn url="add-setting" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <SettingListTable />
      </div>
    </PageBody>
  );
};

export default SettingList;
